exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-group[data-v-6914c772] {\n  margin-bottom: 1rem;\n}\n#verificationCode[data-v-6914c772] {\n  font-size: 1.5rem;\n  letter-spacing: 0.5rem;\n}\n", ""]);

// exports
